import axios, {AxiosResponse} from 'axios'
import {ID} from '../../../../../../_metronic/helpers'
import {GetProtocolResponse, Protocol, ProtocolForms} from './_models'

const API_URL = process.env.REACT_APP_THEME_API_URL
const PROTOCOLO_URL = `${API_URL}/protocol`

const getProtocols = (
  page: number,
  limit: number,
  query?: Object
): Promise<GetProtocolResponse> => {
  const params = {page, limit, ...query}

  return axios
    .get(`${PROTOCOLO_URL}`, {params})
    .then((d: AxiosResponse<GetProtocolResponse>) => d.data)
}

const createProtocol = (dep: ProtocolForms): Promise<Protocol> => {
  return axios.post(`${PROTOCOLO_URL}`, dep).then((d: AxiosResponse<Protocol>) => d.data)
}

const updateProtocol = (dep: ProtocolForms): Promise<Protocol> => {
  return axios.patch(`${PROTOCOLO_URL}/${dep.id}`, dep).then((d: AxiosResponse<Protocol>) => d.data)
}

const deleteProtocol = (id: ID): Promise<Protocol> => {
  return axios.delete(`${PROTOCOLO_URL}/${id}`).then((d: AxiosResponse<Protocol>) => d.data)
}

const getProtocolById = (id: ID): Promise<Protocol> => {
  return axios.get(`${PROTOCOLO_URL}/${id}`).then((d: AxiosResponse<Protocol>) => d.data)
}

const getNextProtocol = (): Promise<Protocol> => {
  return axios.get(`${PROTOCOLO_URL}/next/number`).then((d: AxiosResponse<Protocol>) => d.data)
}

export {
  getProtocols,
  createProtocol,
  updateProtocol,
  deleteProtocol,
  getProtocolById,
  getNextProtocol,
}
